<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"padding-bottom:200px;"' class="container " >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"border-radius:30px"' class="text-center shadow m-4 p-4" >
                <template #default>لیپوماتیک   </template>
                </m-h1><m-h4 v-bind='{...{},...{}}' :style='""' class="text-center m-5" >
                <template #default>یک عمل جراحی لاغری است که چربی اضافی را در نواحی شکم، ران‌ها، پهلوها، غبغب، بازو، صورت و پشت کمر از بین می‌برد. این روش به دلیل عوارض و درد کمتر شناخته شده است، نیازی به بیهوشی ندارد و خطرات ناشی از بیهوشی را از بین می‌برد.    <m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/lipo\/D0EF9E0C-7A0F-4E68-A5BD-0F3FFFD83F531.jpeg","imageAfter":"https:\/\/api.arair.ir\/storage\/lipo\/D0EF9E0C-7A0F-4E68-A5BD-0F3FFFD83F53.jpeg","direction":"horizontal","beforeText":"\u0642\u0628\u0644","afterText":"\u0628\u0639\u062f"},...{}}' :style='""' class="col-12 mx-auto text-center" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/lipo\/62F7C928-0D95-44AC-96B8-C55A0D3448872.jpeg","imageAfter":"https:\/\/api.arair.ir\/storage\/lipo\/62F7C928-0D95-44AC-96B8-C55A0D344887.jpeg","direction":"horizontal","beforeText":"\u0642\u0628\u0644","afterText":"\u0628\u0639\u062f"},...{}}' :style='""' class="col-12 mx-auto text-center" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/lipo\/8A2EEF11-B143-4E9E-B5C3-7362A293FE301.jpeg","imageAfter":"https:\/\/api.arair.ir\/storage\/lipo\/8A2EEF11-B143-4E9E-B5C3-7362A293FE30.jpeg","direction":"horizontal","beforeText":"\u0642\u0628\u0644","afterText":"\u0628\u0639\u062f"},...{}}' :style='""' class="col-12 mx-auto text-center" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200></template>
                </m-h4><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/lipo\/82AFF4A3-C19B-4662-AB59-6CCE0403D1722.jpeg","imageAfter":"https:\/\/api.arair.ir\/storage\/lipo\/82AFF4A3-C19B-4662-AB59-6CCE0403D172.jpeg","direction":"horizontal","beforeText":"\u0642\u0628\u0644","afterText":"\u0628\u0639\u062f"},...{}}' :style='""' class="col-12 mx-auto text-center" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/lipo\/5ADDD0DA-1F9A-453F-8300-8452B77208922.jpeg","imageAfter":"https:\/\/api.arair.ir\/storage\/lipo\/5ADDD0DA-1F9A-453F-8300-8452B7720892.jpeg","direction":"vertical","beforeText":"\u0642\u0628\u0644","afterText":"\u0628\u0639\u062f"},...{}}' :style='""' class="col-12 mx-auto text-center" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/lipo\/900CCE57-90BC-484B-93F0-A037AEE8DB689.jpeg","imageAfter":"https:\/\/api.arair.ir\/storage\/lipo\/900CCE57-90BC-484B-93F0-A037AEE8DB68.jpeg","direction":"vertical","beforeText":"\u0642\u0628\u0644","afterText":"\u0628\u0639\u062f"},...{}}' :style='""' class="col-12 mx-auto text-center" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mSection200 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section200';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mH4,mSection200 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
